var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { get, deletE, patch, post } from '../utils';
import hash from 'object-hash';
export var getSchedulerList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/schedules/all', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var deleteSchedule = function (id, type, date) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = {
                    params: {}
                };
                if (!(type === 'series')) return [3 /*break*/, 2];
                return [4 /*yield*/, deletE("schedules/" + id, payload)];
            case 1:
                _b.sent();
                return [3 /*break*/, 5];
            case 2:
                _a = {};
                return [4 /*yield*/, deletE("schedules/" + id + "/" + date, payload)];
            case 3: return [4 /*yield*/, (_b.sent()).data];
            case 4: return [2 /*return*/, (_a.data = _b.sent(),
                    _a.id = id,
                    _a)];
            case 5: return [2 /*return*/, id];
        }
    });
}); };
export var checkSchedule = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        payload = {
            params: {}
        };
        return [2 /*return*/, deletE("schedules/" + id + "?skipdeletion=true", payload)];
    });
}); };
export var updateSchedule = function (editedScheduleConfig, id, initialScheduleConfig) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, headers, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                delete initialScheduleConfig.ScheduleTimeZone;
                delete initialScheduleConfig['prjacc'];
                payload = __assign(__assign({}, editedScheduleConfig), { id: id });
                headers = {
                    'initial-entity-hash': hash(JSON.stringify(initialScheduleConfig))
                };
                _a = {};
                return [4 /*yield*/, post("schedules", payload, { headers: headers })];
            case 1: return [4 /*yield*/, (_b.sent()).data];
            case 2: return [2 /*return*/, (_a.data = _b.sent(),
                    // data: await (await patch(`schedules/${id}`, payload, { headers })).data,
                    _a.id = id,
                    _a)];
        }
    });
}); };
// INSERT HASH FUNCTIONALITY HERE:
export var updateOccurrence = function (schedule, id, date) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = schedule;
                _a = {};
                return [4 /*yield*/, post("/schedules/" + id + "/" + date, __assign(__assign({}, payload), { id: id }))];
            case 1: return [4 /*yield*/, (_b.sent()).data];
            case 2: return [2 /*return*/, (_a.data = _b.sent(),
                    _a.id = id,
                    _a)];
        }
    });
}); };
export var enableSchedule = function (id, date, type, enable) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, endpoint, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                payload = {};
                endpoint = type === 'occurrence'
                    ? "schedules/" + id + "/" + (enable ? 'enable' : 'disable') + "/" + date
                    : "schedules/" + id + "/" + (enable ? 'enable' : 'disable');
                _a = {};
                return [4 /*yield*/, post(endpoint, payload)];
            case 1: return [4 /*yield*/, (_b.sent()).data];
            case 2: return [2 /*return*/, (_a.data = _b.sent(),
                    _a.id = id,
                    _a)];
        }
    });
}); };
export var addSchedule = function (schedule) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = schedule;
                return [4 /*yield*/, post("schedules", payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContactFilterList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/filters?isPhone=false&isFilter=true', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getPhoneFilterList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/filters?isPhone=true&isFilter=true', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var getContactSortingList = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/filters?isPhone=false&isFilter=false', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// export const getCampaignListForScheduler = async () => {
//   const payload = {
//     params: {},
//   };
//   return await get('/campaigns/all', payload);
// };
export var getFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/filters/all', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
// export const getSubStudioFlows = async (parentStudioFlow: string) => {
//   const payload = {
//     params: {},
//   };
//   const parentStudioFlowSid = parentStudioFlow;
//   return await get(`/twilio/studioflows/${parentStudioFlowSid}`, payload);
// };
export var getSchedulesBetweenTimes = function (startTime, endTime) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get("/schedules?startTime=" + startTime + "&endTime=" + endTime, payload)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
export var getAllHolidays = function () { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, get('/holidays/all', payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var addHoliday = function (holiday) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = holiday;
                return [4 /*yield*/, post("holidays", payload)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
export var updateHoliday = function (holiday, initialHoliday) { return __awaiter(void 0, void 0, void 0, function () {
    var payload, initialConfigHash, headers, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                delete initialHoliday['prjacc'];
                payload = holiday;
                initialConfigHash = hash(JSON.stringify(initialHoliday));
                headers = {
                    'initial-entity-hash': initialConfigHash
                };
                _a = {};
                return [4 /*yield*/, patch("holidays/" + initialHoliday.id, payload, { headers: headers })];
            case 1: return [4 /*yield*/, (_b.sent()).data];
            case 2: return [2 /*return*/, (_a.data = _b.sent(),
                    _a.id = initialHoliday.id,
                    _a)];
        }
    });
}); };
export var deleteHoliday = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                payload = {
                    params: {}
                };
                return [4 /*yield*/, deletE("holidays/" + id, payload)];
            case 1:
                _a.sent();
                return [2 /*return*/, id];
        }
    });
}); };
//# sourceMappingURL=Scheduler.API.js.map